import { combineEpics }                from 'redux-observable';
import { applicationBootstrappedEpic } from './ApplicationBootstrapped/ApplicationBootstrappedEpic';
import { showErrorNotificationEpic }   from './ShowErrorNotification/ShowErrorNotificationEpic';
import { checkSessionRequestEpic }     from './CheckSession/CheckSessionRequestEpic';

export const applicationEpics = combineEpics(
  applicationBootstrappedEpic,
  checkSessionRequestEpic,
  showErrorNotificationEpic,
);
